import { useEffect } from "react";
function ListenOnClickOutside(ref, callback) {
  const eventType = 'click';
  const listener = event => {
    const listeningElement = ref.current;
    const interactingElement = event.target;
    if (!listeningElement) {
      return;
    }
    if (!listeningElement.contains(interactingElement)) {
      callback();
    }
  };
  useEffect(() => {
    document.addEventListener(eventType, listener);
    const disableListener = () => document.removeEventListener(eventType, listener);
    return disableListener;
  });
}
const listenOnClickOutside = ListenOnClickOutside;
export { listenOnClickOutside };